import appHistory from "../app/appHistory";
import updateURLSearchParams from "./updateURLSearchParams";

export interface IFormPathWithSearchParams {
    [name: string]: string | number | undefined;
}

const formPathWithSearchParams = (params: IFormPathWithSearchParams, pathname: string = '') => {
    const urlParams = new URLSearchParams(window.location.search);
    const updateSearchParams = updateURLSearchParams(urlParams, params);

    return `${pathname || appHistory.location.pathname}?${updateSearchParams.toString()}`;
}

export default formPathWithSearchParams;
